import { colors } from '../../colors';
var pagination = {
  activeColor: colors.equineStone,
  defaultColor: colors.equineSnow
};
export default pagination;

// activeColor: --sc-pagination--active-color
// defaultColor: --sc-pagination--default-color
// src/components/molecules/Pagination/Pagination.style.js